$(function () {

  $(document).on('cart.requestStarted', function (event, cart) {
    var $html = `<div class="jsc-page-loading">
                   <div class="jsc-spinner-container">
                     <div class="jsc-spinner"></div>
                   </div>
                 </div>`;
    $('body').prepend($html);
  });
  $(document).on('cart.requestComplete', function (event, cart) {
    $('.jsc-page-loading').remove();
  });

  warrantyLogin();
  $('html').click(function () {
    $('.jsc-popup-work').hide();
    $('.jsc-popup-compatible').hide();
  });
  $('.jsc-tip-work-btn').click(function (e) {
    e.stopPropagation();
  });

  // addRemoveCartNote();
  if (location.href.includes('/cart')) {
    /*
    * When removed this, it caused difficulties for "warehouse people",
    * because they take delivery date/time values from the order note `delivery_date`
    * */
    echantoAttr();
  }

  if (location.href.includes('/account/login?checkout_url=/apps/product-registration?form=warranty')) {
    $('.guest_login-wrap').hide();
  }

});

faqAnchor = (e) => {
  var href = $(e).attr('href');
  $('html, body').animate({
    scrollTop: $(href).offset().top - 100
  }, 100);
}

warrantyLogin = () => {
  if ($('#login-customer').length > 0) {
    $('a').each(function () {
      var href = $(this).attr('href');
      if (href && href.includes('/account/login?checkout_url=/apps/product-registration?form=warranty')) {
        $(this).attr('href', '/apps/product-registration?form=warranty')
      }
    });
  }
}

checkTerms = (e) => {

  if (!$('#CartTerms').is(':checked')) {
    $(e).prop("disabled", true);
    $('#checkTermsbox').show();
    setTimeout(function () {
      $(e).prop("disabled", false);
    }, 0);
    return false;

  } else {
    $('#checkTermsbox').hide();
    return true;
  }
}

openexcTooltip = () => {
  $('.jsc-exc-cylinders-tooltip').toggle();
}

openworkPopup = () => {
  $('.jsc-popup-work').toggle();
}
opencompatiblePopup = () => {
  $('.jsc-popup-compatible').toggle();
}
selectCompare = (e) => {
  var makerType = $(e).val();
  var dataColumn = $(e).parents('.jsc-column').attr('data-column');
  $('.jsc-prod-compare-array').each(function () {
    var thismakerType = $(this).attr('data-maker-type');
    if (makerType == thismakerType) {
      var thismakerarray = $(this).val().split(']');

      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-img').attr("src", thismakerarray[1]);
      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-desc').html(thismakerarray[2]);
      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-work').html(thismakerarray[4]);
      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-fizz').html(thismakerarray[5]);
      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-cylinder').html(thismakerarray[6]);
      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-material').html(thismakerarray[7]);
      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-dimensions').html(thismakerarray[10]);
      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-price').html(thismakerarray[11]);
      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-view-now').attr("href", thismakerarray[12]);

      if (thismakerarray[8] == 'true') {
        $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-safe').children().remove();
        $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-safe').append('<span class="fa fa-star"></span><span class="" style="color: #009fe3;"> YES</span>');
      } else {
        $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-safe').children().remove();
        $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-safe').append('<span>Not included <br>(can be purchased separately)</span>');
      }

      if (thismakerarray[9].includes('0.8L') || thismakerarray[9].includes('0.8l') || thismakerarray[9].includes('0.8')) {
        $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-compatible').children().remove();
        $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-compatible').append('<span class="">' + thismakerarray[9] + '</span>');
      } else {
        $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-compatible').children().remove();
        $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-compare-compatible').append('<span class="fa fa-star"></span><span class="" style="color: #009fe3;">' + thismakerarray[9] + '</span>');
      }

      var thismakercolorarray = thismakerarray[3].split(',');
      var white = 'fff,FFF,FFFFFF,ffffff';
      $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-col-wrap').children().remove();

      for (var i = 0; i < thismakercolorarray.length; i++) {
        if (white.includes(thismakercolorarray[i])) {
          $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-col-wrap').append('<div class="jsc-col-compare" style="background-color: #' + thismakercolorarray[i] + ';border: 2px solid #d9d9d9!important;"></div>');
        } else {
          $(e).parents('.jsc-compare-table').find('.jsc-column[data-column="' + dataColumn + '"] .jsc-col-wrap').append('<div class="jsc-col-compare" style="background-color: #' + thismakercolorarray[i] + ';"></div>');
        }
      }

    }
  });
}


/**
 * Deprecated. use {@link sodaStreamHandleExchangeCartNote()}.
 * @param setTime
 */
addRemoveCartNote = (setTime) => {

  function handleCartNote() {
    console.log('handleCartNote():');
    if ($('.jsc-trade-remove').length > 0 || $('.jsc-exchange-remove').length > 0) {
      console.log('Clearing cart note.');
      CartJS.setNote('');
    }
    let $exchange = $('.jsc-exchange-incart');
    if ($exchange.length > 0) {
      let total_cylinders = 0;
      $exchange.each(function () {
        total_cylinders += parseInt($(this).val()) || 0;
      });
      const cart_note = 'EXCHANGE – ' + total_cylinders + ' Cylinders (delivery)';
      console.log(cart_note);
      CartJS.setNote(cart_note);
    }
    if ($('.jsc-trade-incart').length > 0) {
      const cart_note = 'EXCHANGE – To collect old machine before releasing the items.';
      console.log('Setting cart note for trade-incart: ' + cart_note)
      CartJS.setNote(cart_note);
    }
  }

  if (setTime) {
    setTimeout(handleCartNote, 1000);
  } else {
    handleCartNote();
  }

}

plustMinusExc = (evt, qty) => {
  setTimeout(function () {
    var curtQTY = $(evt).siblings('.quantity__input').val();
    $('.jsc-qty-exc').text(curtQTY);
    var curtQTYint = parseInt(curtQTY);
    if (curtQTYint > 1) {
      $('.jsc-s-exc').text('s');
    } else {
      $('.jsc-s-exc').text('');
    }

  }, 10);
}

closePopupvid = (evt) => {
  $(evt).parents('.modal.micromodal-slide').removeClass('is-open');
  $(evt).parents('.modal.micromodal-slide').find('video').trigger('pause');
}

playVid = (evt) => {
  $(evt).parent().find('video').trigger('pause');
  $(evt).parent().find('video').toggleClass('jsc-vid-play');
  $(evt).parent().toggleClass('jsc-play');
  if ($(evt).parent().find('video').hasClass('jsc-vid-play')) {
    $(evt).parent().find('video').trigger('play');
  } else {
    $(evt).parent().find('video').trigger('pause');
  }
}

echantoAttr = () => {

  window.ZapietEvent.listen('checkoutEnabled', function (checkout_method) {
    var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-spinner"></div>
                  </div>
                </div>`;
    $('body').prepend($html);
    var cart;
    var zapDate;
    var zapTime;
    jQuery.getJSON('/cart.js', function (c) {
      // We can access cart info
      cart = c;
    }).done(function () {

      zapDate = cart.attributes['Delivery-Date'];
      zapTime = cart.attributes['Delivery-Time'];

      var dateAr = zapDate.split('/');
      var newDate = dateAr[2] + '-' + dateAr[1] + '-' + dateAr[0];
      var newTime = zapTime.replace(/:00 /g, "").replace(/PM/g, 'pm').replace(/AM/g, 'am');
      CartJS.setAttributes({
          "delivery_date": newDate,
          "delivery_timeslot": newTime
        },
        {
          // Define a success callback to display a success message.
          "success": function (data, textStatus, jqXHR) {
            $('.jsc-page-loading').remove();
          },
          // Define an error callback to display an error message.
          "error": function (jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown);
            $('.jsc-page-loading').remove();
          }
        });

    });

  });

}

closesuccPopup = () => {
  $('.jsc-form-succ-popup').hide();
  $('.jsc-overlay-form-succ').hide();
}

//Start: bypass checkout when ONLY gift card is in cart
checkChecbox = (e, bypassZapiet) => {
  if (bypassZapiet) {
    $(e).prop("disabled", true);

    var _shopUrl = $('#shopUrl').val() + '/checkout';
    console.log(_shopUrl);
    window.location.replace(_shopUrl);

  }
}
//END: bypass checkout when ONLY gift card is in cart

showPopup = () => {

  //var badgeDetails = $(e).parents('.prod-badge-container').find('.badge-details');


  // $('.jsc-promo-popup-container-modal').show();
  $('.jsc-promo-popup-container-modal').addClass('active');

}
closePopup = () => {
  $('.jsc-promo-popup-container-modal').removeClass('active');
  // $('.jsc-promo-popup-container-modal').hide();
}

tabChange = (evt, tabID) => {
  console.log(tabID);
  $('.jsc-tab-exc').removeClass('active');
  $(evt).addClass('active');
  $('.jsc-tab-cont').removeClass('active');
  $('#' + tabID + '.jsc-tab-cont').addClass('active');
  console.log($('#' + tabID + '.jsc-tab-cont'));
}

excpopupOpen = () => {
  $('.jsc-exc-pop').addClass('active');
  $('.jsc-exc-pop-overlay').show();
}
excpopupClose = () => {
  $('.jsc-exc-pop').removeClass('active');
  $('.jsc-exc-pop-overlay').hide();
}

//start:display art maker section
artShowSection = (e) => {
  var $this = $(e);
  var $siblingsBtn = $this.siblings('.jsc-art-section');
  $siblingsBtn.show();
  $this.hide();
}
